import { Icon } from './types';

export const ChevronRight = ({ svgProps, pathProps }: Icon) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="chevron-right"
    {...svgProps}
  >
    <path
      d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6Z"
      fill="currentColor"
      {...pathProps}
    />
  </svg>
);
